import { useUpdateItemsInCart } from "@/hooks/useCart";
import { IconButton } from "@material-ui/core";
import DeleteOutlineIcon from "@material-ui/icons/DeleteOutline";

interface IProps {
  ids: string[];
}

const DeleteButton: React.FC<IProps> = ({ ids }) => {
  const { loading, updateItemsInCart } = useUpdateItemsInCart();

  return (
    <IconButton
      color="primary"
      onClick={() => updateItemsInCart(ids)}
      disabled={loading}
    >
      <DeleteOutlineIcon />
    </IconButton>
  );
};

export default DeleteButton;
